import { createApp } from 'vue';
import App from '@/_modules/App.vue';
import store from '@/_modules/store';

export default class pageTop {
  constructor() {
    //this.getHeight100();
    this.winH = 0;
    this.conH = 0;
    this.init();
  }

  init() {
    // vue3
    const app = createApp(App);
    app.use(store);
    app.mount('#c-container');
  }

  start() {
    gPG.rootHTML.classList.add('is-load-end');
  }

  getHeight100() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }
}
